"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = _interopRequireDefault(require("./grid"));

var _spacing = _interopRequireDefault(require("./spacing"));

var StyledCell = (
/*#__PURE__*/
0, _styledBase["default"])('div', {
  target: "egnxgpi0",
  label: "StyledCell"
})(function (props) {
  return props.columnSpan ? _grid["default"].span({
    base: props.columnSpan.base,
    sm: props.columnSpan.sm,
    md: props.columnSpan.md,
    lg: props.columnSpan.lg
  }) : '';
}, " ", function (props) {
  return props.fullWidth ? _grid["default"].fullWidth : null;
}, " ", function (props) {
  return props.textAlign ? "text-align: ".concat(props.textAlign, ";") : null;
}, " @media only screen and (-ms-high-contrast:none){flex-grow:1;margin-bottom:", _spacing["default"].Close, ";}> p:first-child,ul:first-child{margin-top:0;}> p:last-child,ul:last-child{margin-bottom:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/** //Cell Component
 * import { Layout } from '@kbbcomponentlibrary/principles';
 * const { Cell } = Layout;
 * */

var Cell = function Cell(props) {
  return _react["default"].createElement(StyledCell, props);
};

Cell.displayName = 'Cell';
Cell.defaultProps = {
  columnSpan: {},
  fullWidth: false,
  textAlign: 'left'
};
Cell.propTypes = {
  /** content */
  children: _propTypes["default"].node,

  /** how many columns spanned on viewports. sm = 564, md = 768, lg = 948 */
  columnSpan: _propTypes["default"].object,

  /** span ALL grid columns in a <Row/> */
  fullWidth: _propTypes["default"].bool,

  /** align text */
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right'])
};
var _default = Cell;
exports["default"] = _default;
Cell.__docgenInfo = {
  "description": "//Cell Component\nimport { Layout } from '@kbbcomponentlibrary/principles';\nconst { Cell } = Layout;",
  "methods": [],
  "displayName": "Cell",
  "props": {
    "columnSpan": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "how many columns spanned on viewports. sm = 564, md = 768, lg = 948"
    },
    "fullWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "span ALL grid columns in a <Row/>"
    },
    "textAlign": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "align text"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "content"
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/Cell.js"] = {
    name: "Cell",
    docgenInfo: Cell.__docgenInfo,
    path: "src/Layout/Cell.js"
  };
}